module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a5787bb7364d8131ed49a8f53037d7f4.svg";